import axios from "@/services/axios.config";
import { toastOnError } from "@/utils/toastOnError";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

const reviewMethodology = async (data: any) =>
	axios
		.post("reviews/submit-review", data)
		.then((res) => res.data.data)
		.catch((err) => Promise.reject(err.response.data as APIResponse));

export default function useSubmitReview() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationKey: ["reviewMethodology"],
		mutationFn: reviewMethodology,
		retry: 0,
		onSuccess() {
			toast.success("Submitted Successfully!");
			queryClient.invalidateQueries({
				queryKey: ["methodologyDetailsWithRound"],
			});
			queryClient.invalidateQueries({
				queryKey: ["basicMethodologyRoundDetails"],
			});

			queryClient.invalidateQueries({
				queryKey: ["methodologiesList"],
			});
			queryClient.invalidateQueries({
				queryKey: ["reviewComments"],
			});
		},
		onError: (err: APIResponse) => {
			toastOnError(err);
		},
	});
}
